module.exports = __webpack_public_path__ + "img/MARCA_NAVEGAM.588e2302.svg";